// El aviso de lo que a la lista le falta. Cada causa va en su propia frase: un nombre que el motor
// no pudo resolver y una evaluación sin cliente registrado se arreglan distinto.
import { ScreenFrameNotice } from '@/shared/patterns/ScreenFrame';

export interface ModeliaCoverageNoticeProps {
    title: string;
    gaps: readonly string[];
    className?: string;
}

/** `null` sin causas: un aviso vacío enseña una alarma que no existe. */
export function ModeliaCoverageNotice({ title, gaps, className }: ModeliaCoverageNoticeProps) {
    if (gaps.length === 0) return null;
    return (
        <ScreenFrameNotice role="status" tone="warning" className={className}>
            <strong className="font-bold">{title}</strong>
            <ul className="mt-1 list-disc space-y-0.5 pl-4">
                {gaps.map((gap) => (
                    <li key={gap}>{gap}</li>
                ))}
            </ul>
        </ScreenFrameNotice>
    );
}
